<template>
    <el-dialog title="交强险保单信息" :visible.sync="dialogVisible" width="400px">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
            <el-form-item label="保单照片" prop="compulsoryTrafficInsurance">
                <up-img :file.sync="form.compulsoryTrafficInsurance" width="200" height="135"></up-img>
            </el-form-item>
            <el-form-item label="保单号" prop="compulsoryTrafficInsuranceNo">
                <el-input v-model="form.compulsoryTrafficInsuranceNo" placeholder="请输入保单号" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="保单起始日期" prop="compulsoryTrafficInsuranceStart">
                <el-date-picker v-model="form.compulsoryTrafficInsuranceStart" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="保单截止日期" prop="compulsoryTrafficInsuranceEnd">
                <el-date-picker v-model="form.compulsoryTrafficInsuranceEnd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                compulsoryTrafficInsurance: '',
                compulsoryTrafficInsuranceNo: '',
                compulsoryTrafficInsuranceStart: '',
                compulsoryTrafficInsuranceEnd: '',
            },
            rules: {
                compulsoryTrafficInsurance: [
                    { required: true, message: '请上传保单照片', trigger: 'change' }
                ],
                compulsoryTrafficInsuranceNo: [
                    { required: true, message: '请输入保单号', trigger: 'change' }
                ],
                compulsoryTrafficInsuranceStart: [
                    { required: true, message: '请选择保单起始日期', trigger: 'change' }
                ],
                compulsoryTrafficInsuranceEnd: [
                    { required: true, message: '请选择保单截止日期', trigger: 'change' }
                ],
            }
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.initForm();
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        initForm() {
            this.form = {
                compulsoryTrafficInsurance: this.info.compulsoryTrafficInsurance || '',
                compulsoryTrafficInsuranceNo: this.info.compulsoryTrafficInsuranceNo || '',
                compulsoryTrafficInsuranceStart: this.info.compulsoryTrafficInsuranceStart * 1000 || '',
                compulsoryTrafficInsuranceEnd: this.info.compulsoryTrafficInsuranceEnd * 1000 || '',
            };
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.form);
                }
            });
        }
    }
}
</script>
